
import React from "react";
import { Box, FormControlLabel, Checkbox, Grid, FormGroup } from "@mui/material";
import { useField, useFormikContext } from "formik";

interface SingleCheckboxGroupProps {
    name: string;
    label: string;
    required?: boolean;
}

const CheckboxGroup: React.FC<SingleCheckboxGroupProps> = ({ name, label, required }) => {
    const [field] = useField(name);
    const { setFieldValue, setFieldTouched, validateField } = useFormikContext<any>();
    const { value = false } = field;

    const handleChange = () => {
        setFieldValue(name, !value);
    };;

    return (
        <Box sx={{ mb: 2 }}>
            <FormGroup>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                border: value ? "2px solid #016D91" : "1px solid #ccc",
                                borderRadius: "4px",
                                cursor: "pointer",
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                    borderColor: "#016D91",
                                    backgroundColor: "#f9f9f9",
                                },
                            }}
                            onClick={handleChange}
                        >
                            <Checkbox
                                checked={value}
                                sx={{
                                    "&.Mui-checked": { color: "#016D91" },
                                    mr: 1,
                                }}
                            />
                            <FormControlLabel
                                control={<></>}
                                label={
                                    <span style={{ fontSize: "16px", color: "#2D2C5F", fontWeight: 500 }}>
                                        {label}
                                    </span>
                                }
                                sx={{ margin: 0, flex: 1 }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </FormGroup>
        </Box>
    );
};

export default React.memo(CheckboxGroup);
